// Ask HANA (Mint-AskHana): hội thoại mẫu, lối tắt, gợi ý theo vai. Dữ liệu mẫu trong bộ nhớ, không nối mô hình thật (docs/streams/I.md).
// Ask HANA chỉ đọc và gợi ý: không trả số tiền, không tự thực thi — thao tác ghi mở sang HANA Ezy để anh duyệt.

export { cite } from '@hana/ask-hana';
export type { ActId, AskAct, Cite, CiteKey, DocField, JobRow, Msg, Tone } from '@hana/ask-hana';
import { cite, type CiteKey, type JobRow, type Msg } from '@hana/ask-hana';

export type ConvKey = 'cutoff' | 'doc' | 'lax' | 'mail' | 'bk' | 'fresh' | 'new';
export type IconKey = 'job' | 'file' | 'ship' | 'mail' | 'task' | 'clock' | 'note' | 'clip' | 'truck';

export const JOBS: JobRow[] = [
  { id: 'SE260622020', route: 'VNCLI → KRPUS · 2×40HC', sub: 'GREENBUD · YM CERTAINTY 089N', left: '3 giờ', pct: 12, tone: 'err', st: 'BK Confirmed' },
  { id: 'SE260609200', route: 'VNCLI → JPTYO · 1×40HC', sub: 'Gỗ Trường Thành Phát · ONE COMPETENCE 112E', left: '7 giờ', pct: 34, tone: 'warn', st: 'BK Confirmed' },
  { id: 'SE260637290', route: 'VNCLI → USLAX · 1×40HC', sub: 'Điện tử Sao Việt · WAN HAI 316 S041', left: '1 ngày', pct: 62, tone: 'warn', st: 'BK Standby' },
];

export const A_CUT: Msg = {
  ai: true, kind: 'jobs', text: '3 job cut-off SI trong 24 giờ làm việc tới', rows: JOBS,
  acts: [{ id: 'remind', k: 'Nhắc SI cho 3 khách', primary: true }], cites: cite('job', 'sop'),
};
export const A_DOC: Msg = {
  ai: true, kind: 'doc', text: 'Đọc xong B/L nháp · 1 điểm lệch so với job SE260609200', doc: ['DBN2605036118.pdf', '2 trang · HBL nháp'],
  fields: [
    { k: 'Shipper', v: 'Gỗ Trường Thành Phát', ok: true }, { k: 'Consignee', v: 'Nordhout BV', ok: true },
    { k: 'POL → POD', v: 'VNCLI → NLRTM', ok: true }, { k: 'Tàu / chuyến', v: 'ONE COMPETENCE 112E', ok: true },
    { k: 'Cont · kg', v: '1×40HC · 18.240 kg', ok: false, why: 'Job ghi 18.420 kg' },
  ],
  acts: [{ id: 'open', k: 'Mở B/L trong Ezy', primary: false }, { id: 'note', k: 'Ghi điểm lệch vào job', primary: true }], cites: cite('jobDetail'),
};
const MONEY_SAMPLE = 'Số tiền job SE260622020 bao nhiêu?';
export const A_LOCK: Msg = { ai: true, kind: 'lock', text: 'Em trả số job, cont, hạn và trạng thái. Số tiền xem ở màn tài chính trong Ezy.', cites: cite('money') };

export const CONV: Record<ConvKey, [string, Msg[]]> = {
  cutoff: ['Job sắp cut-off SI', [{ me: true, text: 'Job nào sắp cut-off SI mà chưa có SI?' }, A_CUT, { me: true, text: MONEY_SAMPLE }, A_LOCK]],
  doc: ['Đọc B/L nháp DBN2605036118', [{ me: true, text: 'Đọc giúp B/L nháp này, khớp job chưa?', files: ['DBN2605036118.pdf'] }, A_DOC]],
  lax: ['Tàu đi LAX tuần 44', [{ me: true, text: 'Tàu nào đi LAX tuần 44?' }, { ai: true, kind: 'plain', text: '3 chuyến VNCLI → USLAX tuần 44: YM CERTAINTY 089N (ETD 25/Oct), ONE COMPETENCE 112E (27/Oct), WAN HAI 316 S041 (29/Oct)', cites: cite('sched') }]],
  mail: ['Mail chưa gán job', [{ me: true, text: 'Mail nào ở info@ chưa gán job?' }, { ai: true, kind: 'plain', text: '4 mail ở info@ chưa gán job · cũ nhất 22/Oct 08:12', cites: cite('box') }]],
  bk: ['Booking chưa Confirmed', [{ me: true, text: 'Booking nào chưa Confirmed?' }, { ai: true, kind: 'plain', text: '3 booking BK Standby quá 24 giờ làm việc', cites: cite('booking') }]],
  fresh: ['Hỏi mới', []],
  new: ['Hỏi mới', []],
};

export const HIST: Array<[string, Array<[ConvKey, IconKey]>]> = [
  ['Hôm nay', [['cutoff', 'job'], ['doc', 'file']]],
  ['Hôm qua', [['lax', 'ship'], ['mail', 'mail']]],
  ['20/Oct', [['bk', 'task']]],
];
export const SAVED: Array<[string, IconKey, string]> = [
  ['Job sắp cut-off của tôi', 'job', 'Job nào sắp cut-off SI mà chưa có SI?'],
  ['B/L chờ release', 'file', 'B/L nào chờ release?'],
  ['Việc quá hạn của tôi', 'task', 'Việc nào của tôi quá hạn?'],
  ['Chuyến đang trễ', 'truck', 'Chuyến nào đang trễ?'],
];

export type RoleKey = 'sale' | 'cs' | 'bkg' | 'ops' | 'acc';
export const ROLES: Record<RoleKey, [string, Array<[string, IconKey]>]> = {
  sale: ['Sale', [['Khách nào 30 ngày chưa có booking?', 'job'], ['Báo giá nào hết hạn tuần này?', 'note'], ['Tàu nào đi LAX tuần 44?', 'ship'], ['Job nào sắp cut-off SI mà chưa có SI?', 'clock']]],
  cs: ['CS', [['Job nào sắp cut-off SI mà chưa có SI?', 'clock'], ['B/L nào chờ release?', 'file'], ['Mail nào ở info@ chưa gán job?', 'mail'], ['Đọc chứng từ từ ảnh chụp', 'clip']]],
  bkg: ['Booking', [['Booking nào chưa Confirmed?', 'task'], ['Hãng nào vừa đổi lịch?', 'ship'], ['Tàu nào đi LAX tuần 44?', 'ship'], ['Cont nào chưa có VGM?', 'job']]],
  ops: ['Điều độ', [['Chuyến nào đang trễ?', 'truck'], ['Cont nào chưa có xe kéo ngày mai?', 'truck'], ['Xe nào sắp hạn đăng kiểm?', 'truck'], ['Việc nào của tôi quá hạn?', 'task']]],
  acc: ['Kế toán', [['Hoá đơn nào chờ phát hành?', 'note'], ['Debit nào khách chưa xác nhận?', 'mail'], ['Phiếu chi nào chờ duyệt?', 'task'], ['Đọc hoá đơn mua vào từ PDF', 'clip']]],
};

export const SAMPLE_FILES = ['DBN2605036118.pdf', 'BL-nhap-chup.jpg'];

/** Hộp xác nhận trước khi mở màn ghi bên Ezy: [tiêu đề, màn, số lượng, đường dẫn]. */
export const CONFIRM: Record<'remind' | 'note', { k: string; screen: string; n: string; to: string }> = {
  remind: { k: 'Nhắc SI cho 3 khách', screen: 'Danh sách Job · lọc cut-off SI', n: '3 job', to: '/ezy/jobs' },
  note: { k: 'Ghi điểm lệch vào job', screen: 'Chi tiết Job SE260609200 › Ghi chú', n: '1 điểm lệch', to: '/ezy/jobs' },
};

/** Bỏ dấu, thường hoá — so khớp câu hỏi không phân biệt dấu. */
export const norm = (s: string): string =>
  s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/\s+/g, ' ').trim();

const PLAIN: Record<string, string> = {
  'khach nao 30 ngay chua co booking?': '3 khách chưa có booking từ 22/Sep: Gốm Minh Long, Nhựa Đông Á, Cơ khí Tân Tiến',
  'b/l nao cho release?': '2 B/L ở BL Wait RLS: SE260631180, SE260628810',
  'viec nao cua toi qua han?': '1 việc quá hạn: nhắc SI SE260622020',
  'chuyen nao dang tre?': '2 chuyến trễ: 50E13970 (40 phút), 51C88211 (25 phút)',
  'booking nao chua confirmed?': '3 booking BK Standby quá 24 giờ làm việc',
};
const CITE_BY_WORD: Array<[string, CiteKey]> = [['b/l', 'bl'], ['viec', 'tasks'], ['chuyen', 'tms'], ['booking', 'booking'], ['khach', 'customers']];

/** Trả lời MẪU cho `?fx=1` (cổng so ảnh) và khi Hub chưa nối worker. Khoá tiền thật do worker / API áp, không do regex ở client. */
export function answer(q: string, files: string[]): Msg {
  const n = norm(q);
  if (n === norm(MONEY_SAMPLE)) return A_LOCK;
  if (files.length) return A_DOC;
  if (/cut-off|cutoff/.test(n)) return A_CUT;
  const hit = PLAIN[n];
  if (hit) {
    const w = CITE_BY_WORD.find(([k]) => n.includes(k));
    return { ai: true, kind: 'plain', text: hit, cites: w ? cite(w[1]) : [] };
  }
  return { ai: true, kind: 'plain', text: 'Anh cho thêm số job, booking hoặc tên khách để em tra chính xác', cites: cite('job') };
}
